import React from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import usePatientPayTableNote from "./hooks/usePatientPayTableNote";  
import { useMemo,useCallback } from "react";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
  
const PatientPayTableNote = () => {  
    const location = useLocation();  
    const { state: stateVal } = location;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    const {
      selectedPatients = [],
      previousScreen = ROUTE_PATHS.PATIENT_PAY_TABLE,
      currentIndex: initialIndex = 0,
    } = currentState;
    console.log(
      "states",
      stateVal,
      currentState,
      selectedPatients,
      initialIndex,
      previousState
    );    const navigateToPage = useCustomNavigate();  
  
    const {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    } = usePatientPayTableNote(selectedPatients, initialIndex);  
  
    const screen_title = "Patient Pay Table Note";  
    const screen_code = "RCPTN001";  
  
    const columns = mode === 'view'  
        ? [  
            { key: 'ptnNote', header: 'Note' },  
            { key: 'chgDate', header: 'Added Date' },  
            { key: 'chgTime', header: 'Added Time' },  
            { key: 'chgUserName', header: 'User' }  
        ]  
        : [  
            { key: 'ptnNote', header: 'Note' }  
        ];  
  
        const handleBack =useCallback(() => {
            if (currentIndex < selectedPatients.length - 1) {
              setCurrentIndex(currentIndex + 1);
            } else {
              const lastScheduleName = selectedPatients[currentIndex]?.ps4PtPaySchTableName || "";
              const updatedParamsData = {
                ...currentState.paramsData,
                ps4PtPaySchTableName: lastScheduleName,
              };
              navigateToPage(previousScreen, [
                ...previousState,
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex,
                },
              ]);
            }
          }, [currentIndex, navigateToPage, setCurrentIndex]);
          
  
          const handleBackAndSetMode = useCallback(() => {
            handleBack();
            setMode("view");
          }, [handleBack, setMode]);  
  
          const handleModeSwitch = useCallback(() => {
            if (mode === "add") {
              setMode("view");
            } else if (mode === "view") {
              setMode("add");
            }
          }, [mode]);
  
          const leftButtons = useMemo(
            () => [
              {
                button_label: "Back",
                button_handeler: handleBackAndSetMode,
                button_key: "F12",
              },
              ...(mode === "add"
                ? [
                    {
                      button_label: "View Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F6",
                    },
                  ]
                : []),
            ],
            [mode, handleBackAndSetMode, handleModeSwitch]
          );  
          const rightButtons = useMemo(
            () => [
              ...(mode === "view"
                ? [
                    {
                      button_label: "Add Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F6",
                    },
                  ]
                : []),
              { button_label: "Export as CSV", button_handeler: exportAsCSV },
            ],
            [mode]
          );
  
    const getName = (selectedPatients, currentIndex) => (  
        <>  
            <strong>Table  </strong>  
            {selectedPatients[currentIndex].ps4PtPaySchTableName} 
            <span className="info-records">
           <strong>    Description  </strong>
        {selectedPatients[currentIndex].ps4PatPayDescription}
      </span>  
        </>  
    );  
  
    return (  
        <div className="container">  
            <ButtonsSection ctaButtons={leftButtons} align="left" />  
            <div className="left-aligned-section">  
                <div className="header-section">  
                    <h1>  
                        {screen_title} - <span className="heading-cod">{screen_code}</span>  
                    </h1>  
                </div>  
                <p className="head-name">{getName(selectedPatients, currentIndex)}</p>  
            </div>  
            <div className="button-sections">  
                <ButtonsSection ctaButtons={rightButtons} align="right" />  
            </div>  
            <NoteTable  
                data={notes}  
                columns={columns}  
                mode={mode}  
                maxLength={55}
                newNotes={newNotes}  
                handleChangeNewNote={handleChangeNewNote}  
                handleSaveNotes={handleSaveNotes}  
            />  
            <NextGenPaginator  
                first={first}  
                rows={rows}  
                totalRecords={totalRecords}  
                currentPage={first / rows}  
                rowsPerPageOptions={[10, 25, 50]}  
                onPageChange={onPageChange}  
            />  
        </div>  
    );  
};  
  
export default PatientPayTableNote;  
